/* eslint-disable jsx-a11y/role-supports-aria-props */
import * as React from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';

interface IComponentProps extends WrappedComponentProps {
  activePaging?: any;
  activeRows?: any;
  activeSorting?: any;
  action?: any;
  label?: any;
  columns?: any;
  filterComponent?: any;
  parentState?: any;
  stateValue?: any;
  actionOpen?: any;
  setStateValue?: any;
  handleChange?: any;
  actionSave?: any;
  reset?: any;
  menuNameOpen?: any;
}

interface IComponentState {
  optionsFromSearch: any;
  sentData: any;
}

type Props = IComponentProps;
type State = IComponentState;

// tato komp. sa aktualne nikde nepouziva
const GroupSelect = class extends React.PureComponent<Props, State> {
  state: Readonly<State> = {
    optionsFromSearch: this.props.filterComponent.values,
    sentData: [],
  };

  constructor(props: Props) {
    super(props);
    this.checkedGroup = this.checkedGroup.bind(this);
    this.checked = this.checked.bind(this);
    this.callReset = this.callReset.bind(this);
    this.callApply = this.callApply.bind(this);
    this.callChecked = this.callChecked.bind(this);
    this.renderLabel = this.renderLabel.bind(this);
  }

  checkedGroup(event: any) {
    event.preventDefault();
    const data = JSON.parse(event.currentTarget.getAttribute('data-items'));

    if (event.currentTarget.checked) {
      Object.values(data).forEach((element: any) => {
        // SetTimeout WTF? a ide inak nie
        setTimeout(() => {
          this.props.setStateValue(
            event,
            element.item,
            true,
            'groupSelect',
            this.props.columns.name
          );
        }, 1);
      });
    } else {
      Object.values(data).forEach((element: any) => {
        // SetTimeout WTF? a ide inak nie
        setTimeout(() => {
          this.props.setStateValue(
            event,
            element.item,
            false,
            'groupSelect',
            this.props.columns.name
          );
        }, 1);
      });
    }
  }

  checked(e: any, item: any) {
    let selectedValue =
      this.props.columns.filter.selectedValue === null
        ? []
        : this.props.columns.filter.selectedValue;
    if (selectedValue.filter((subItem: any) => item === subItem).length === 0) {
      selectedValue.push(item);
    } else {
      selectedValue = selectedValue.filter((subItem: any) => subItem !== item);
    }
    this.props.actionSave(
      this.props.columns.name,
      selectedValue,
      e,
      this.props.filterComponent.type,
      this.props.columns.title
    );
  }

  callReset() {
    const { columns } = this.props;
    this.props.reset(columns, 'groupSelect', true);
  }

  callApply(event: any) {
    const { columns, filterComponent } = this.props;
    const sentData: any = [];

    if (
      this.props.parentState.parentState &&
      this.props.parentState.parentState.groupSelect &&
      this.props.parentState.parentState.groupSelect[columns.name]
    ) {
      Object.entries(this.props.parentState.parentState.groupSelect[columns.name]).forEach(
        ([key, value]) => {
          if (value === true) {
            sentData.push(
              Object.values(filterComponent.values)
                .map((item: any) => item.filter((subItem: any) => subItem.item === key))
                .filter((item) => item.length !== 0)[0][0].value
            );
          }
        }
      );
    }
    this.setState({ sentData });

    const id = columns.filter.multiple ? sentData : sentData[0];
    this.props.actionSave(columns.name, id, event, filterComponent.type, columns.title);
  }

  callChecked(e: any) {
    this.props.setStateValue(
      e,
      e.currentTarget.value,
      e.currentTarget.checked,
      'groupSelect',
      this.props.columns.name
    );
  }

  actionOpen(e: any) {
    this.props.actionOpen(e, this.props.columns.name);
  }

  action(e: any) {
    this.props.action(this.props.columns.name, e);
  }

  callClick(e: any) {
    const { columns, filterComponent } = this.props;
    const { name, title } = columns;
    const { type } = filterComponent;

    if (!filterComponent.multiple) {
      const item = e.currentTarget.getAttribute('data-item');
      if (Object.keys(this.props.parentState.parentState.groupSelect).length !== 0) {
        this.props.parentState.parentState.groupSelect[name] = {};
      }
      this.props.setStateValue(e, item.item, true, 'groupSelect', name);
      this.props.actionSave(name, [item.value], e, type, title);
    }
  }

  renderLabel() {
    let labelValue = '';

    if (
      this.props.filterComponent.selectedValue.length === 1 &&
      Object.values(this.props.parentState.parentState.groupSelect[this.props.columns.name])
        .length !== 0
    ) {
      const select: any = this.props.parentState.parentState.groupSelect[this.props.columns.name];
      if (select) {
        const selectValue = Object.entries(select).find((item: any) => item[1] === true);
        if (selectValue) {
          labelValue = selectValue[0];
        }
      }
    }

    if (
      this.props.filterComponent.selectedValue.length !== 0 &&
      this.props.filterComponent.selectedValue.length !== 1
    ) {
      labelValue = this.props.filterComponent.selectedValue.length;
    }

    if (this.props.filterComponent.selectedValue.length < 2) {
      labelValue += '';
    } else if (this.props.filterComponent.selectedValue.length >= 5) {
      labelValue += ` ${this.props.intl.formatMessage({ id: 'table.items5' })}`;
    } else {
      labelValue += ` ${this.props.intl.formatMessage({
        id: 'table.items2-4',
      })}`;
    }

    return (
      <span onClick={this.actionOpen}>
        <a
          href="#"
          title={this.props.intl.formatMessage({ id: 'table.filter.button' })}
          className="dropdown-toggle text-white text-decoration-none"
          id="dropdownMenu13"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          {this.props.columns.title}: {labelValue}
        </a>
        <a
          href="#"
          title={this.props.intl.formatMessage({ id: 'table.filter.remove' })}
          className="text-white"
          onClick={this.action}
          style={{ padding: '8px', margin: '-8px -8px -8px 0' }}
        >
          <i className="cmd-icon cmd-icon-remove-sm" />
        </a>
      </span>
    );
  }

  render() {
    const { props } = this; // tslint:disable-line
    const { columns, filterComponent, intl } = props;

    return (
      <div
        data-cy={`group-select-popup-${columns.name}`}
        className={`label ${props.label ? 'label-primary mb-xs position-relative label--filter' : ''}
          ${this.props.menuNameOpen[this.props.columns.name] === this.props.label ? 'open' : ''}`}
        style={{ padding: !props.label ? '0px' : '9px 8px 8px 8px' }}
      >
        {props.label && <this.renderLabel />}
        <div
          style={{ overflowY: 'hidden' }}
          className="dropdown-menu dropdown-menu-custom fs-2 js-dropdown-keep-open"
          aria-labelledby="dropdownMenu13"
        >
          {filterComponent.filtered && (
            <div className="pt-1 pb-2 px-2 border-bottom-on">
              <input
                type="text"
                data-cy="group-selecet-filter-input"
                onChange={(e) => {
                  const filteredGroups: any = [];
                  Object.keys(filterComponent.values).forEach((key) => {
                    const filtered = filterComponent.values[key].filter((i: any) =>
                      i.item
                        .toLowerCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .includes(
                          e.target.value
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                        )
                    );
                    if (filtered.length > 0) {
                      filteredGroups[key] = filtered;
                    }
                  });
                  if (e.target.value !== '') {
                    this.setState({ optionsFromSearch: filteredGroups });
                  } else {
                    this.setState({
                      optionsFromSearch: filterComponent.values,
                    });
                  }
                }} // tslint:disable-line
                className="form-control font-weight-normal fs-2"
                placeholder={filterComponent.placeholder}
              />{' '}
            </div>
          )}
          <div className="scroll-area">
            {Object.values(this.state.optionsFromSearch).map((item: any, key: any) => (
              <div key={key}>
                <div className="e-checkbox pl-1 py-1 d-block text-black font-weight-bold">
                  <label style={{ width: '100%' }}>
                    {' '}
                    {this.props.filterComponent.multiple && (
                      <input
                        type="checkbox"
                        data-cy="group-select-fitler-checkbox"
                        className="js-indeterminate"
                        data-items={JSON.stringify(item)}
                        checked={
                          item
                            .map((itemFilter: any) =>
                              this.state.sentData.find(
                                (subItem: any) => subItem === itemFilter.value
                              )
                            )
                            .filter(Boolean).length === item.length
                        }
                        onChange={this.checkedGroup}
                      />
                    )}
                    <span
                      className="pl-5 font-weight-bold"
                      style={{
                        cursor: `${filterComponent.multiple ? 'pointer' : 'default'}`,
                      }}
                    >
                      {[Object.keys(this.state.optionsFromSearch)[key]][0]}
                    </span>
                  </label>
                  {Object.values(item).map((subItem: any, subKey: any) => (
                    <div
                      style={{
                        cursor: `${!filterComponent.multiple ? 'pointer' : 'default'}`,
                        backgroundColor:
                          this.props.parentState.parentState.groupSelect &&
                          this.props.parentState.parentState.groupSelect[columns.name] &&
                          Object.keys(
                            this.props.parentState.parentState.groupSelect[columns.name]
                          ).filter(
                            (item3, index) =>
                              item3 === subItem.item &&
                              Object.values(
                                this.props.parentState.parentState.groupSelect[columns.name]
                              )[index] === true
                          ).length !== 0
                            ? 'rgb(242, 249, 255)'
                            : '',
                      }}
                      onClick={this.callClick}
                      data-cy={`group-select-filter-checkbox-${key}`}
                      key={subKey}
                      data-item={subItem}
                      className={`e-checkbox pl-1 py-1 d-block text-black pl-5 font-weight-normal ${
                        subKey % 2 !== 0 ? 'bg-gray-light' : ''
                      }`}
                    >
                      <label style={{ width: '100%' }}>
                        {' '}
                        {filterComponent.multiple && (
                          <input
                            type="checkbox"
                            data-cy={`group-select-filter-checkbox-${key}`}
                            checked={
                              this.props.parentState.parentState.groupSelect &&
                              this.props.parentState.parentState.groupSelect[columns.name] &&
                              Object.keys(
                                this.props.parentState.parentState.groupSelect[columns.name]
                              ).filter(
                                (item3, index) =>
                                  item3 === subItem.item &&
                                  Object.values(
                                    this.props.parentState.parentState.groupSelect[columns.name]
                                  )[index] === true
                              ).length !== 0
                            }
                            onChange={this.callChecked}
                            value={subItem.item}
                          />
                        )}
                        {!filterComponent.multiple && (
                          <span
                            className="pl-5"
                            style={{ color: '#555' }}
                            onClick={this.callClick}
                            data-item={subItem}
                          >
                            {subItem.item}
                          </span>
                        )}
                        {filterComponent.multiple && <span className="pl-5">{subItem.item}</span>}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {this.props.filterComponent.multiple && (
            <div className="row m-0 px-1 py-1 pt-2">
              <div className="col-6 px-xs">
                <a
                  href="#"
                  id="reset"
                  title={intl.formatMessage({ id: 'table.filter.reset' })}
                  data-cy="group-select-filter-button-reset"
                  className={`e-button d-flex ${
                    this.props.parentState.parentState.groupSelect &&
                    this.props.parentState.parentState.groupSelect[columns.name] &&
                    Object.entries(this.props.parentState.parentState.groupSelect[columns.name])
                      .map((item) => item[1] === true)
                      .filter((item) => item === true).length === 0 // tslint:disable-line
                      ? 'disabled'
                      : ''
                  } `}
                  onClick={this.callReset}
                >
                  Reset
                </a>
              </div>
              <div className="col-6 px-xs">
                <a
                  href="#"
                  title={intl.formatMessage({ id: 'table.apply' })}
                  data-cy="group-select-filter-button-apply"
                  className={`e-button e-button--gray d-flex ${
                    this.props.parentState.parentState.groupSelect &&
                    this.props.parentState.parentState.groupSelect[columns.name] &&
                    Object.entries(this.props.parentState.parentState.groupSelect[columns.name])
                      .map((item) => item[1] === true)
                      .filter((item) => item === true).length === 0 // tslint:disable-line
                      ? 'disabled'
                      : ''
                  } `}
                  onClick={this.callApply}
                >
                  <FormattedMessage id="table.apply" />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
};

export default injectIntl(GroupSelect);
